import { useState } from 'react';
import { Music4, Menu, X, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { UserMenu } from './UserMenu';
import { Button } from '../ui/Button';

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isLoggedIn = false;

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <>
      <nav className="fixed w-full z-50 bg-white/80 backdrop-blur-md border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 gold-gradient rounded-full flex items-center justify-center text-white shadow-lg">
              <Music4 size={24} /> 
            </div>
            <span className="text-xl font-bold tracking-tight text-slate-800">
              Encant<span className="text-gold-primary">.Me</span>
            </span>
          </Link>
          
          <div className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-600">
            <a href="#como-funciona" className="hover:text-gold-primary transition-colors">Como funciona</a>
            <a href="#presente-fisico" className="hover:text-gold-primary transition-colors">Presente Físico</a>
            <a href="/sobre-nos" className="hover:text-gold-primary transition-colors">Sobre Nós</a>
            {isLoggedIn ? <UserMenu /> : (
              <>
                <Link to="/login" className="hover:text-gold-primary transition-colors">Entrar</Link>
                <Button size="sm">Começar Agora</Button>
              </>
            )}
          </div>

          <button 
            className="md:hidden p-2 text-slate-600 hover:bg-slate-100 rounded-xl transition-colors"
            onClick={toggleMenu}
          >
            {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </nav>

      <div className={`
        fixed inset-0 z-40 bg-white md:hidden transition-transform duration-500 ease-in-out
        ${isMenuOpen ? 'translate-y-0' : '-translate-y-full'}
      `}>
        <div className="flex flex-col h-full pt-28 px-8 pb-12">
          <div className="flex flex-col gap-8 text-2xl font-bold text-slate-800">
            <a href="#como-funciona" onClick={toggleMenu} className="flex justify-between items-center border-b border-slate-50 pb-4">
              Como funciona <ArrowRight className="text-gold-primary" />
            </a>
            <a href="#estilos" onClick={toggleMenu} className="flex justify-between items-center border-b border-slate-50 pb-4">
              Estilos <ArrowRight className="text-gold-primary" />
            </a>
            <a href="#presente-fisico" onClick={toggleMenu} className="flex justify-between items-center border-b border-slate-50 pb-4">
              Presente Físico <ArrowRight className="text-gold-primary" />
            </a>
            <a href="/sobre-nos" onClick={toggleMenu} className="flex justify-between items-center border-b border-slate-50 pb-4">
              Sobre Nós <ArrowRight className="text-gold-primary" />
            </a>
          </div>

          <div className="mt-auto space-y-4">
            {isLoggedIn ? (
              <Button className="w-full" onClick={toggleMenu}>Ir para Minha Área</Button>
            ) : (
              <>
                <Link to="/login" onClick={toggleMenu}>
                  <Button variant="outline" className="w-full mb-4">Entrar na Conta</Button>
                </Link>
                <Button className="w-full">Começar Agora</Button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};